import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import SnackbarUtils from 'utils/SnackbarUtils';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CONTRATO_STATUS_EM_EDICAO } from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import { getNumberOfCurrencyStr } from '../../../../../utils/InputMaskUtils';

class GenericDados extends GenericContent {
  getSubmitMessageSuccess = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.successAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.successDistratoSalvar;
        default:
          return this.props.languageValues.successContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.successAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.successDistratoPreCadastro;
      default:
        return this.props.languageValues.successContratoPreCadastro;
    }
  };

  getSubmitMessageError = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.erroAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.erroDistratoSalvar;
        default:
          return this.props.languageValues.erroContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroDistratoPreCadastro;
      default:
        return this.props.languageValues.erroContratoPreCadastro;
    }
  };

  toSubmit = (index, data, callbackStart, callbackSuccess, callbackError) => {
    if (index < this.props.totalBullets - 1) {
      this.toNextContent();
      return;
    }
    if (!this.hasPermissions()) {
      return;
    }
    if (typeof callbackStart === 'function') {
      callbackStart();
    }
    const valorAssessoria = getNumberOfCurrencyStr(data.valorAssessoria, ',');
    const valorFormacao = getNumberOfCurrencyStr(data.valorFormacao, ',');
    const valorOutros = getNumberOfCurrencyStr(data.valorOutros, ',');
    const valorReuniao = getNumberOfCurrencyStr(data.valorReuniao, ',');

    const valorReembolsoHospedagem = getNumberOfCurrencyStr(
      data.valorReembolsoHospedagem,
      ','
    );
    const valorReembolsoAlimentacao = getNumberOfCurrencyStr(
      data.valorReembolsoAlimentacao,
      ','
    );
    const valorReembolsoDeslocamento = getNumberOfCurrencyStr(
      data.valorReembolsoDeslocamento,
      ','
    );
    const valorReembolsoPedagio = getNumberOfCurrencyStr(
      data.valorReembolsoPedagio,
      ','
    );
    const valorReembolsoOutros = getNumberOfCurrencyStr(
      data.valorReembolsoOutros,
      ','
    );
    this.props.contratoAssessorRegisterPreEtapa(
      {
        codCoop: data.codCoop,
        cpfAssessores: data.cpfAssessores,
        dataDistrato:
          data.versaoContrato === CONTRATO_VERSAO_DISTRATO
            ? moment(data.dataDistrato, 'DD MM YYYY').format('DDMMYYYY')
            : '',
        dataFim:
          data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
            ? moment(data.dataFim, 'DD MM YYYY').format('DDMMYYYY')
            : '',
        dataInicio:
          data.versaoContrato !== CONTRATO_VERSAO_DISTRATO
            ? moment(data.dataInicio, 'DD MM YYYY').format('DDMMYYYY')
            : '',
        emailCoop: data.emailCoop,
        idAditivo:
          data.versaoContrato === CONTRATO_VERSAO_ADITIVO
            ? data.idAditivo
            : null,
        idDistrato:
          data.versaoContrato === CONTRATO_VERSAO_DISTRATO
            ? data.idDistrato
            : null,
        idContrato: data.idContrato,
        idEmpresa: data.idEmpresa,
        cnpjEmpresa: data.cnpjEmpresa,
        versaoContrato: data.versaoContrato,
        totalMeses: Number(data.totalMeses),
        valorAssessoria: valorAssessoria > 0 ? valorAssessoria : 0,
        valorFormacao: valorFormacao > 0 ? valorFormacao : 0,
        valorOutros: valorOutros > 0 ? valorOutros : 0,
        valorReuniao: valorReuniao > 0 ? valorReuniao : 0,
        valorReembolsoAlimentacao: !data.reembolsoAlimentacaoEnabled
          ? null
          : valorReembolsoAlimentacao,
        valorReembolsoDeslocamento: !data.reembolsoDeslocamentoEnabled
          ? null
          : valorReembolsoDeslocamento,
        valorReembolsoHospedagem: !data.reembolsoHospedagemEnabled
          ? null
          : valorReembolsoHospedagem,
        valorReembolsoOutros: !data.reembolsoOutrosEnabled
          ? null
          : valorReembolsoOutros,
        valorReembolsoPedagio: !data.reembolsoPedagioEnabled
          ? null
          : valorReembolsoPedagio,
        reembolsoOutrosDescricao: data.reembolsoOutrosDescricao,
        reembolsoObservacoes: data.observacoesReembolso,
      },
      (resp) => {
        SnackbarUtils.enqueueSnackbar({
          message: this.getSubmitMessageSuccess(data),
          options: {
            variant: 'success',
          },
        });
        if (typeof callbackError === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText || this.getSubmitMessageError(data),
          options: {
            variant: 'error',
          },
        });
        if (typeof callbackError === 'function') {
          callbackError();
        }
      }
    );
  };

  editing = () => {
    return this.props.editing || false;
  };

  disabledWhenAditivo = () => {
    return this.props.contratosAssessores.contratoEditing.versaoContrato === CONTRATO_VERSAO_ADITIVO;
  };

  disabledWhenDistrato = () => {
    return this.props.contratosAssessores.contratoEditing.versaoContrato === CONTRATO_VERSAO_DISTRATO;
  };

  hasPermissions = () => {
    if (!this.props.contratosAssessores.contratoEditing.ativo) {
      return false;
    }
    if (this.editing()) {
      return (
        this.props.contratosAssessores.contratoEditing.flgStatus ===
        CONTRATO_STATUS_EM_EDICAO &&
        this.props.auth.userPermissions.contratos.assessor.edit
      );
    }
    return (
      this.props.contratosAssessores.contratoEditing.flgStatus <=
      CONTRATO_STATUS_EM_EDICAO &&
      this.props.auth.userPermissions.contratos.assessor.register
    );
  };

  setValue = (event, callback) => {
    let newEvent = { ...event };
    if (newEvent.target.name === 'totalMeses') {
      newEvent.target.value = !newEvent.target.value
        ? 0
        : Number(newEvent.target.value).toString();
    }
    this.checkboxReembolsoValidations(
      newEvent.target.name,
      newEvent.target.value
    );
    this.setState(
      {
        ...this.state,
        [newEvent.target.name + 'Changed']: true,
      },
      () => {
        if (typeof callback === 'function') {
          callback();
        }
      }
    );
    this.props.changeContratoAssessorEditingValue(
      newEvent.target.name,
      newEvent.target.value
    );
  };

  checkboxReembolsoValidations = (name, value) => {
    if (name === 'reembolsoHospedagemEnabled') {
      if (!value) {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoHospedagem',
          null
        );
      } else {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoHospedagem',
          0
        );
      }
    }
    if (name === 'reembolsoDeslocamentoEnabled') {
      if (!value) {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoDeslocamento',
          null
        );
      } else {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoDeslocamento',
          0
        );
      }
    }
    if (name === 'reembolsoAlimentacaoEnabled') {
      if (!value) {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoAlimentacao',
          null
        );
      } else {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoAlimentacao',
          0
        );
      }
    }
    if (name === 'reembolsoPedagioEnabled') {
      if (!value) {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoPedagio',
          null
        );
      } else {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoPedagio',
          0
        );
      }
    }
    if (name === 'reembolsoOutrosEnabled') {
      if (!value) {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoOutros',
          null
        );
        this.props.changeContratoAssessorEditingValue(
          'reembolsoOutrosDescricao',
          null
        );
      } else {
        this.props.changeContratoAssessorEditingValue(
          'valorReembolsoOutros',
          0
        );
        this.props.changeContratoAssessorEditingValue(
          'reembolsoOutrosDescricao',
          ''
        );
      }
    }
  };

  render() {
    return <></>;
  }
}

GenericDados.propTypes = {
  editing: PropTypes.bool,
  loading: PropTypes.bool,
  totalBullets: PropTypes.number.isRequired,
  bulletsIndex: PropTypes.number.isRequired,
};

export default GenericDados;
